module.exports = __webpack_public_path__ + "static/media/correctProtects.3bfd2d77.mp3";